// @ts-nocheck
// Auto-migrated from js/mockData.js
// ---------- 8 层漏斗事件（PRD 3.6） ----------
const FUNNEL_LEVELS = [
  { code: "share", name: "分享", en: "Share", desc: "用户点击分享按钮" },
  { code: "impression", name: "送达", en: "Impression", desc: "消息成功发送到渠道" },
  { code: "reach", name: "展示", en: "Reach", desc: "消息被接收方看到" },
  { code: "click", name: "点击", en: "Click", desc: "点击分享链接" },
  { code: "download", name: "下载", en: "Download", desc: "开始下载应用" },
  { code: "install", name: "安装", en: "Install", desc: "完成安装并首次启动" },
  { code: "register", name: "注册", en: "Register", desc: "创建游戏账号" },
  { code: "tutorial", name: "教程", en: "Tutorial", desc: "完成新手引导" },
  { code: "purchase", name: "付费", en: "Purchase", desc: "首次付费", hasAmount: true },
];

const FUNNEL_DATA = [
  { level: "share", times: 100000, people: 25000, rate: 100 },
  { level: "impression", times: 95000, people: 23750, rate: 95 },
  { level: "reach", times: 76000, people: 19000, rate: 80 },
  { level: "click", times: 22800, people: 5700, rate: 30 },
  { level: "download", times: 13680, people: 3420, rate: 60 },
  { level: "install", times: 11628, people: 2907, rate: 85 },
  { level: "register", times: 8139, people: 2035, rate: 70 },
  { level: "tutorial", times: 7325, people: 1831, rate: 90 },
  { level: "purchase", times: 1831, people: 458, rate: 25, amount: 22875 },
];

// ---------- 渠道对比数据 ----------
const CHANNEL_COMPARE = [
  { code: "facebook", name: "Facebook", share: 35000, click_rate: 32, install: 1200, cpi: 2.5, roi: 450, retention: { d1: 65, d7: 32, d30: 18 } },
  { code: "twitter", name: "Twitter / X", share: 28000, click_rate: 28, install: 980, cpi: 1.8, roi: 380, retention: { d1: 58, d7: 28, d30: 14 } },
  { code: "discord", name: "Discord", share: 18000, click_rate: 45, install: 850, cpi: 3.2, roi: 520, retention: { d1: 72, d7: 38, d30: 22 } },
  { code: "whatsapp", name: "WhatsApp", share: 42000, click_rate: 18, install: 420, cpi: 4.1, roi: 180, retention: { d1: 48, d7: 22, d30: 10 } },
  { code: "telegram", name: "Telegram", share: 15000, click_rate: 25, install: 380, cpi: 2.9, roi: 290, retention: { d1: 60, d7: 30, d30: 16 } },
  { code: "line", name: "LINE", share: 8500, click_rate: 22, install: 220, cpi: 2.4, roi: 310, retention: { d1: 55, d7: 26, d30: 14 } },
];
// ---------- 通知 ----------
const NOTIFICATIONS = [
  { type: "release", title: "SDK v2.4.0 已发布", desc: "新增 TikTok 分享渠道，建议尽快升级", time: "2 小时前", icon: "🚀" },
  { type: "config", title: "王者征途 NA-Android 配置已更新", desc: "Discord 渠道转化率提升 3.2%", time: "昨天", icon: "✅" },
  { type: "warning", title: "系统维护通知", desc: "5 月 18 日 02:00 - 04:00（UTC+8）进行例行维护", time: "2 天前", icon: "⚙️" },
  { type: "alert", title: "Facebook 渠道异常", desc: "过去 24 小时点击安装率下降 35%，建议检查", time: "3 天前", icon: "⚠️" },
];

// ---------- 用户路径示例（PRD 4.4.3） ----------
const USER_PATH_EXAMPLE = [
  { time: "2024-05-10 14:30:00", event: "Share", desc: "用户 A 分享到 Facebook", icon: "📤" },
  { time: "2024-05-10 14:32:15", event: "Click", desc: "好友 B 点击链接", delay: "2 分钟" },
  { time: "2024-05-10 14:37:42", event: "Download", desc: "好友 B 开始下载", delay: "5 分钟" },
  { time: "2024-05-10 14:40:28", event: "Install", desc: "好友 B 完成安装并启动", delay: "3 分钟" },
  { time: "2024-05-10 14:50:13", event: "Register", desc: "好友 B 注册账号 user_b_8842", delay: "10 分钟" },
  { time: "2024-05-10 15:05:47", event: "Tutorial", desc: "好友 B 完成新手引导", delay: "15 分钟" },
  { time: "2024-05-12 20:15:32", event: "Purchase", desc: "好友 B 首次付费 $9.99", delay: "2 天", highlight: true },
];

// ---------- 趋势数据（最近 14 天） ----------
const TREND_DATA = (() => {
  const dates = [];
  const now = new Date("2026-05-15");
  for (let i = 13; i >= 0; i--) {
    const d = new Date(now.getTime() - i * 86400000);
    dates.push(`${d.getMonth() + 1}/${d.getDate()}`);
  }
  return {
    dates,
    share: [8120, 8456, 9012, 9234, 9678, 10234, 11023, 10567, 10890, 11234, 11876, 12345, 12567, 12890],
    click: [2436, 2537, 2704, 2770, 2903, 3070, 3307, 3170, 3267, 3370, 3563, 3704, 3770, 3867],
    install: [580, 612, 670, 685, 712, 765, 825, 790, 815, 845, 890, 920, 940, 968],
    purchase: [78, 82, 89, 91, 95, 102, 110, 105, 108, 112, 118, 123, 125, 129],
  };
})();
// ---------- 分享记录（运营管理 / 分享管理） ----------
const SHARE_RECORDS = [
  { id: "s_2026051815", time: "2026-05-18 13:35:18", game: "王者征途", pkg: "US-iOS", channel: "facebook", sharer: "user_a_3219", target_url: "https://share.kqst.io/a9f3ce", status: "completed", funnel: "purchase", refCode: "ref_a9f3ce2b8d", config_id: "cfg_pkg_001", landing_page_id: "lp_001_new", landing_source: "temple", value: 9.99 },
  { id: "s_2026051814", time: "2026-05-18 13:32:42", game: "梦幻西游 Global", pkg: "TW-iOS", channel: "line", sharer: "user_b_8842", target_url: "https://share.kqst.io/d3a8b2", status: "completed", funnel: "install", refCode: "ref_d3a8b2c1f9", config_id: "cfg_pkg_002", landing_page_id: "lp_002_tw", landing_source: "temple", value: 0 },
  { id: "s_2026051813", time: "2026-05-18 13:30:11", game: "王者征途", pkg: "US-Google Play", channel: "discord", sharer: "user_c_9921", target_url: "https://share.kqst.io/e7f4a1", status: "completed", funnel: "click", refCode: "ref_e7f4a1b2c3", config_id: "cfg_plan_001", landing_page_id: "lp_001_return", landing_source: "temple", value: 0 },
  { id: "s_2026051812", time: "2026-05-18 13:28:55", game: "Match Hero", pkg: "BR-Google Play", channel: "whatsapp", sharer: "user_d_1029", target_url: "https://share.kqst.io/f8d2e3", status: "failed", funnel: "share", refCode: "ref_f8d2e3a1b9", config_id: "cfg_default", landing_page_id: "lp_default", landing_source: "default", value: 0, error: "Crawler 抓取失败" },
  { id: "s_2026051811", time: "2026-05-18 13:25:38", game: "王者征途", pkg: "GB-iOS", channel: "twitter", sharer: "user_e_2210", target_url: "https://share.kqst.io/g1h2i3", status: "completed", funnel: "register", refCode: "ref_g1h2i3j4k5", config_id: "cfg_plan_001", landing_page_id: "lp_001_new", landing_source: "temple", value: 0 },
  { id: "s_2026051810", time: "2026-05-18 13:22:09", game: "梦幻西游 Global", pkg: "US-iOS", channel: "telegram", sharer: "user_f_4567", target_url: "https://share.kqst.io/h3l4m5", status: "completed", funnel: "tutorial", refCode: "ref_h3l4m5n6o7", config_id: "cfg_plan_002", landing_page_id: "lp_003_event_url", landing_source: "url", value: 0 },
  { id: "s_2026051809", time: "2026-05-18 13:18:46", game: "王者征途", pkg: "JP-iOS", channel: "line", sharer: "user_g_7788", target_url: "https://share.kqst.io/i9p0q1", status: "expired", funnel: "click", refCode: "ref_i9p0q1r2s3", config_id: "cfg_plan_001", landing_page_id: "lp_001_return", landing_source: "temple", value: 0 },
  { id: "s_2026051808", time: "2026-05-18 13:15:22", game: "Match Hero", pkg: "US-iOS", channel: "facebook", sharer: "user_h_3344", target_url: "https://share.kqst.io/j4t5u6", status: "completed", funnel: "purchase", refCode: "ref_j4t5u6v7w8", config_id: "cfg_default", landing_page_id: "lp_default", landing_source: "default", value: 4.99 },
  { id: "s_2026051807", time: "2026-05-18 13:11:58", game: "王者征途", pkg: "US-iOS", channel: "messenger", sharer: "user_i_5566", target_url: "https://share.kqst.io/k7x8y9", status: "completed", funnel: "install", refCode: "ref_k7x8y9z0a1", config_id: "cfg_pkg_001", landing_page_id: "lp_001_new", landing_source: "temple", value: 0 },
  { id: "s_2026051806", time: "2026-05-18 13:08:14", game: "梦幻西游 Global", pkg: "US-Google Play", channel: "reddit", sharer: "user_j_2233", target_url: "https://share.kqst.io/l2b3c4", status: "completed", funnel: "click", refCode: "ref_l2b3c4d5e6", config_id: "cfg_plan_002", landing_page_id: "lp_003_event_pay", landing_source: "temple", value: 0 },
];

// ---------- 全局统计 mock（管理员 / 全局统计） ----------
const GLOBAL_STATS = {
  // 平台总览
  total: {
    games: 4,
    packages: 8,
    operators: 18,
    developers: 12,
    today_share: 26366,
    today_install: 2057,
    today_revenue: 46005,
    mtd_revenue: 1245680,
  },
  // Top 游戏（在 MOCK 装配后填入）
  top_games: [],
  // 渠道汇总（与 CHANNEL_COMPARE 同形）
  channel_summary: null,
  // 区域分布
  region_dist: [
    { region: "NA", name: "北美", share: 38520, install: 3120, revenue: 18650 },
    { region: "EU", name: "欧洲", share: 22340, install: 1856, revenue: 8920 },
    { region: "APAC", name: "亚太", share: 28120, install: 2245, revenue: 12340 },
    { region: "SEA", name: "东南亚", share: 18560, install: 1567, revenue: 4280 },
    { region: "LATAM", name: "拉美", share: 9230, install: 880, revenue: 1820 },
  ],
};

export { FUNNEL_LEVELS, FUNNEL_DATA, CHANNEL_COMPARE, TREND_DATA, USER_PATH_EXAMPLE, SHARE_RECORDS, GLOBAL_STATS, NOTIFICATIONS };
